module.exports = __webpack_public_path__ + "static/media/solo14.6d4ea98b.JPG";